
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const FooterContainer = styled.footer`
  background: ${({ theme }) => theme.text_primary};
  padding: 32px 40px 20px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  @media (max-width: 768px) {
    padding: 24px 20px 16px 20px;
  }
`;

const TopSection = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
    text-align: center;
  }
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const LogoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LogoText = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.bg};
  letter-spacing: 1px;
`;

const Tagline = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.bg + "99"};
  line-height: 1.5;
  margin: 0;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 28px;
  align-items: center;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
  }
`;

const FooterLink = styled(NavLink)`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.bg};
  text-decoration: none;
  opacity: 0.75;
  transition: opacity 0.2s;
  &:hover {
    opacity: 1;
  }
`;

const Divider = styled.div`
  width: 100%;
  max-width: 900px;
  height: 1px;
  background: ${({ theme }) => theme.bg + "25"};
`;

const Copyright = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.bg + "60"};
  text-align: center;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <TopSection>
        <Brand>
          <LogoRow>
            <LogoText>Krist</LogoText>
          </LogoRow>
          <Tagline>Modern fashion for every occasion.</Tagline>
        </Brand>

        <NavLinks>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/shop">Shop</FooterLink>
          <FooterLink to="/NewArrival">New Arrivals</FooterLink>
          <FooterLink to="/Contact">Contact</FooterLink>
        </NavLinks>
      </TopSection>

      <Divider />

      <Copyright>© {new Date().getFullYear()} Krist. All rights reserved.</Copyright>
    </FooterContainer>
  );
};

export default Footer;